@if (ssr.isClientSide) {
    {{ appString }}
}
